export const REQUEST = "stat/REQUEST";
export const REQUEST_FAIL = "stat/REQUEST_FAIL";
export const POST_OK = "stat/POST_OK";
export const POST_COMPLETE = "stat/POST_COMPLETE";
export const RESET = "stat/RESET";
